<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {lookup2,disabledBeforeTodayDates} from '@/apis/common'
import {saveOrder} from '@/apis/order'
import LanguageSwitch from '../../components/language-switch';
import {
  required
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "SUPPLIER TO ZERO LEVEL 2 REVIEW APPLICATION FORM",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,DatePicker,Multiselect,LanguageSwitch},
  validations: {
    form: {
      clientName: { 
            required,
      },
      taxCode: { 
        check(value){
            if (localStorage.getItem('language')!="zh-CN"&&value!=null && value.trim().length === 0) {
              return false;
            }else{
              return true;
            }                
        },
      },
      country: { 
        required,
      },
      industry: { 
        required,
      },      
      address: { 
            required,
      },
      contact: { 
            required,
      },
      title: { 
            required,
      },
      mobile: { 
            required,
      },
      email: { 
            required,
      },
      companyInfo:{
          wwt:{
            required
          },
          coverarea:{
            required
          },
          employee:{
            required
          },
          openingHour:{
            required
          },
          productType:{
            required
          },
          technology:{
            required
          },
          materials:{
            required
          },
          cmc:{
            required
          },
          numberofChemical:{
            required
          },
          mrsl:{
            required
          },
          chemicalUsed:{
            required
          },
      },
      orderDetail:{
        auditDateFrom:{
          required
        },
        auditDateTo:{
          required
        },
        model:{
          required
        },
          experience:{
          required
        },
          finishLevel1:{
          required
        },
          zdhcID:{
          required
        },       
      }
    },
  },
  props:{
    sales:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      title: "SUPPLIER TO ZERO LEVEL 2 REVIEW APPLICATION FORM",
      orderNo:null,
      clientNo:null,
      showTaxCode:false,
      disabledDates: disabledBeforeTodayDates,
      form:{
        orderId:null,
        orderType:"ZLR",
        orderSource:"ON-LINE",
        orderStatus:'N',
        paymentStatus:'Y',
        orderDetail:{
          model:"O",
          experience:"F",
          finishLevel1:"Y",
          auditDateFrom:"",
          auditDateTo:"",
          zdhcID:""
        },
        clientId:null,
        clientName:"",
        clientNameEn:"",
        taxCode:"",
        country:"",
        province:"",
        city:"",
        station:"",
        address:"",
        addressEn:"",
        promoteBrand:"",
        industry:"",
        companyInfo:{
          productType:"",
          technology:"",
          materials:"",
          wwt:"",
          coverarea:"",
          employee:"",
          openingHour:"",
          fromFactoryAirport:"",
          cmc:"",
          numberofChemical:"",
          mrsl:"Y",
          chemicalUsed:"",
        },
        contact:"",
        email:"",
        mobile:"",
        title:"",
        department:"",
        salesTag:"",
      },
      submitted:false,
      success:false,
      lookupRawData:{},
      lookupData:{
        industry:[],
        cnty:{},
      },
      lookupDataSelected:{
        industry:[],
        cnty:[]
      },
    };
  },
  created(){
    if(this.$route.query.tag!=undefined){
      this.form.salesTag = this.$route.query.tag;
    }
    this.init();
  },
  watch:{
    "lookupDataSelected.cnty"(){
      if(this.lookupDataSelected.cnty.value!=undefined){
        this.form.country = this.lookupDataSelected.cnty.value
      }
    },
    "lookupDataSelected.industry"(){
      if(this.lookupDataSelected.industry.value!=undefined){
        this.form.industry = this.lookupDataSelected.industry.value
      }
    },    
    "form.address"(){
      if(this.form.address.indexOf("省")!=-1||this.form.address.indexOf("市")!=-1){
        let address = this.form.address.replace("，",",").split("市")[0].replace("中国","").trim()
        if(address.indexOf("省")!=-1){
          let province_city = address.split("省")
          this.form.city = ""||province_city[1].trim()
        }else{
          this.form.city = address
        }
      }
    },    
  },
  methods: {
    async init(){
      // 初始化数据字典
      this.lookupRawData = await lookup2("INDUSTRY,TRAVEL,CNTY,YES_NO,ZERO_LEVEL2_EXP,ZERO_LEVEL2_RM");
      this.lookupData.industry = this.lookupRawData["INDUSTRY"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.cnty = this.lookupRawData["CNTY"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.yesno = this.lookupRawData["YES_NO"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.experience = this.lookupRawData["ZERO_LEVEL2_EXP"].map(item=>{return {...item,labelCn:item.label}});
      this.lookupData.model = this.lookupRawData["ZERO_LEVEL2_RM"].map(item=>{return {...item,labelCn:item.label}});
      this.changeLookupLanguage()
    },
    changeLookupLanguage(){
      if(localStorage.getItem('language')=="zh-CN"){
        this.showTaxCode = false;
        this.lookupData.industry = this.lookupData.industry.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.yesno = this.lookupData.yesno.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.experience = this.lookupData.experience.map(item=>{return {...item,label:item.labelCn}});
        this.lookupData.model = this.lookupData.model.map(item=>{return {...item,label:item.labelCn}});
      }else{
        this.showTaxCode = true;
        this.lookupData.industry = this.lookupData.industry.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.cnty = this.lookupData.cnty.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.yesno = this.lookupData.yesno.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.experience = this.lookupData.experience.map(item=>{return {...item,label:item.labelEn}});
        this.lookupData.model = this.lookupData.model.map(item=>{return {...item,label:item.labelEn}});        
      }
    },
    handleSaveClient() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.success = false
            return;
        } else {
          let params = {...this.form}
          params.sales = this.sales
          params.companyInfo = JSON.stringify(this.form.companyInfo)
          params.orderDetail = JSON.stringify(this.form.orderDetail)
          params.language = localStorage.getItem('language')
          params.serviceYear = this.form.orderDetail.auditDateFrom.substring(0,4)
          if(this.lookupDataSelected.industry.value!=undefined){
            params.industry = this.lookupDataSelected.industry.value
          }
          if(this.lookupDataSelected.cnty.value!=undefined){
            params.country = this.lookupDataSelected.cnty.value
          }
          this.success = true
          saveOrder('ZLR',params).then(()=>{
            Swal.fire(this.$t("common.successMsg"),"", "success");
          }).catch(()=>{
            this.success = false;
          })
        }
    },
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
    }

  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span>{{$t("zero.formName")}}</h5>
                          </div>
                        </div>
                        <language-switch @change="changeLookupLanguage"></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                    <div class="card-header d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                    01
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <h5 class="card-title">{{$t("common.verfRequirement")}}</h5>
                        </div>
                    </div>
                    <div class="card-body">
                      <div class="col-lg-12 mb-3">
                          <label class="form-label mb-3 d-flex">{{$t("zero.experience")}}:</label>
                          <div class="form-check form-check-inline" v-for="(item,index) in lookupData.experience" :key="index">
                            <input
                              type="radio"
                              class="form-check-input"
                              :value="item.value"
                              v-model="form.orderDetail.experience"
                            />
                            <label class="form-check-label"
                              >{{item.label}}</label
                            >
                          </div>                          
                      </div>
                      <div class="col-lg-12 mb-3">
                          <label class="form-label mb-3 d-flex">{{$t("zero.finishLevel1")}}:</label>
                          <div class="form-check form-check-inline" v-for="(item,index) in lookupData.yesno" :key="index">
                            <input
                              type="radio"
                              class="form-check-input"
                              :value="item.value"
                              v-model="form.orderDetail.finishLevel1"
                            />
                            <label class="form-check-label"
                              >{{item.label}}</label
                            >
                          </div>                          
                      </div>
                      <div class="col-lg-12 mb-3">
                          <label class="form-label mb-3 d-flex">{{$t("zero.model")}}:</label>
                          <div class="form-check form-check-inline" v-for="(item,index) in lookupData.model" :key="index">
                            <input
                              type="radio"
                              class="form-check-input"
                              :value="item.value"
                              v-model="form.orderDetail.model"
                            />
                            <label class="form-check-label"
                              >{{item.label}}</label
                            >
                          </div>                          
                      </div>
                      <div class="row">
                        <div class="col-md-6 mb-3">
                          <label class="form-label" for="zdhcID">{{$t("zero.zdhcID")}}:</label>
                          <input
                            type="text"
                            class="form-control"
                            id="zdhcID"
                            v-model="form.orderDetail.zdhcID"
                            :class="{
                                            'is-invalid': submitted && $v.form.orderDetail.zdhcID.$error,
                                        }"/>
                                        <div
                                            v-if="submitted && $v.form.orderDetail.zdhcID.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.orderDetail.zdhcID.required">
                                                  {{$t("common.requiredError")}}.
                                                </span>
                                        </div>
                        </div>
                        <div class="col-md-6 mb-3">
                          <label class="form-label" for="promoteBrand">{{$t("fem.promoteBrand")}} :</label>
                          <input
                            type="email"
                            class="form-control"
                            id="promoteBrand"
                            v-model="form.promoteBrand"/>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">{{$t("zero.serviceDate")}} :</label>
                        <div class="row">
                          <div class="col-md-6">
                            <date-picker
                              v-model="form.orderDetail.auditDateFrom"
                              format="YYYY-MM-DD"
                              value-type="format"
                              :disabled-date="disabledDates"
                              :first-day-of-week="1"
                              lang="en"
                              placeholder="from"
                              :class="{
                                  'is-invalid': submitted && $v.form.orderDetail.auditDateFrom.$error,
                              }"
                            ></date-picker>
                            <div
                                v-if="submitted && $v.form.orderDetail.auditDateFrom.$error"
                                class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.orderDetail.auditDateFrom.required">
                                      {{$t("fem.auditDateError")}}.
                                    </span>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <date-picker
                              v-model="form.orderDetail.auditDateTo"
                              format="YYYY-MM-DD"
                              value-type="format"
                              :disabled-date="disabledDates"
                              :first-day-of-week="1"
                              lang="en"
                              placeholder="to"
                              :class="{
                                  'is-invalid': submitted && $v.form.orderDetail.auditDateTo.$error,
                              }"
                            ></date-picker>
                            <div
                                v-if="submitted && $v.form.orderDetail.auditDateTo.$error"
                                class="invalid-feedback"
                                >
                                    <span v-if="!$v.form.orderDetail.auditDateTo.required">
                                      {{$t("fem.auditDateError")}}.
                                    </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <div class="card border shadow-none mb-5">
                    <div class="card-header d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                            <div class="avatar">
                                <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                    02
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <h5 class="card-title">{{$t("common.baseInfo")}}</h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <div>
                            <div class="row">
                                <div class="col-lg-6 mb-3">
                                        <label class="form-label" for="gen-info-name-input">{{$t("common.clientNameLocal")}}</label>
                                        <input type="text" class="form-control" id="gen-info-name-input" v-model="form.clientName"
                                        :class="{
                                            'is-invalid': submitted && $v.form.clientName.$error,
                                        }">
                                        <div
                                            v-if="submitted && $v.form.clientName.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.clientName.required">
                                                  {{$t("common.clientNameLocalError")}}.
                                                </span>
                                        </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="mb-3">
                                        <label class="form-label" for="gen-info-name-en-input">{{$t("common.clientNameEn")}}</label>
                                        <input type="text" class="form-control" id="gen-info-name-en-input" v-model="form.clientNameEn">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6 mb-3">
                                      <label class="form-label" for="gen-info-taxcode-input">{{$t("common.taxCode")}}</label>
                                      <input type="text" class="form-control" id="gen-info-taxcode-input" v-model="form.taxCode"
                                      :class="{
                                          'is-invalid': submitted && $v.form.taxCode.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.taxCode.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.taxCode.check">
                                                {{$t("common.taxCodeError")}}.
                                              </span>
                                      </div>
                              </div>
                          </div>                                  
                            <div class="row">
                              <div class="col-lg-6 mb-3">
                                <label class="form-label" for="gen-info-country-input">{{$t("common.country")}}</label>
                                  <multiselect 
                                  id="gen-info-country-input"
                                  v-model="lookupDataSelected.cnty" 
                                  :options="lookupData.cnty"
                                  label="label"
                                  track-by="value"
                                  :class="{
                                          'is-invalid': submitted && $v.form.country.$error,
                                      }"
                                  ></multiselect>
                                  <div
                                      v-if="submitted && $v.form.country.$error"
                                      class="invalid-feedback"
                                      >
                                          <span v-if="!$v.form.country.required">
                                            {{$t("common.countryError")}}.
                                          </span>
                                  </div>
                              </div>
                              <div class="col-lg-6 mb-3">
                                    <label class="form-label" for="gen-info-province-input">{{$t("common.province")}}</label>
                                    <input type="text" class="form-control" id="gen-info-province-input" v-model="form.province">
                            </div>                                     
                          </div>                            
                            <div class="row">
                                <div class="col-lg-6 mb-3">
                                        <label class="form-label" for="gen-info-address-input">{{$t("common.addressLocal")}}</label>
                                        <input type="text" class="form-control" id="gen-info-address-input" v-model="form.address"
                                        :class="{
                                            'is-invalid': submitted && $v.form.address.$error,
                                        }">
                                        <div
                                            v-if="submitted && $v.form.address.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.address.required">
                                                  {{$t("common.addressLocalError")}}.
                                                </span>
                                        </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="mb-3">
                                        <label class="form-label" for="gen-info-address-en-input">{{$t("common.addressEn")}}</label>
                                        <input type="text" class="form-control" id="gen-info-address-en-input" v-model="form.addressEn">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                              <div class="col-lg-6 mb-3">
                                      <label class="form-label" for="gen-info-station-input">{{$t("common.station")}}</label>
                                      <input type="text" class="form-control" id="gen-info-station-input" v-model="form.station">
                              </div> 
                              <div class="col-lg-6 mb-3">
                                      <label class="form-label" for="gen-info-station-input">{{$t("zero.fromFactoryAirport")}}</label>
                                      <input type="text" class="form-control" id="gen-info-station-input" v-model="form.companyInfo.fromFactoryAirport">
                              </div>                                               
                          </div>   
                          <div class="row">
                              <div class="col-lg-4 mb-3">
                                <label class="form-label" for="employee">{{$t("zero.openingHour")}}</label>
                                <input type="text" class="form-control" id="employee"  v-model="form.companyInfo.openingHour"
                                :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.openingHour.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.openingHour.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.openingHour.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                              </div>
                              <div class="col-lg-4 mb-3">
                                      <label class="form-label" for="coverarea">{{$t("fem.coverarea")}}</label>
                                      <input type="text" class="form-control" id="coverarea" v-model="form.companyInfo.coverarea"
                                      :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.coverarea.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.coverarea.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.coverarea.required">
                                                {{$t("fem.coverareaError")}}.
                                              </span>
                                      </div>
                              </div>
                                <div class="col-lg-4">
                                    <div class="mb-3">
                                        <label class="form-label" for="employee">{{$t("fem.employee")}}</label>
                                        <input type="text" class="form-control" id="employee"  v-model="form.companyInfo.employee"
                                        :class="{
                                            'is-invalid': submitted && $v.form.companyInfo.employee.$error,
                                        }">
                                        <div
                                            v-if="submitted && $v.form.companyInfo.employee.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.companyInfo.employee.required">
                                                  {{$t("fem.employeeError")}}.
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6 mb-3">
                                    <label class="form-label" for="gen-info-industry-input">{{$t("common.industry")}}</label>
                                    <multiselect 
                                    id="gen-info-industry-input"
                                    v-model="lookupDataSelected.industry" 
                                    :options="lookupData.industry"
                                    label="label"
                                    track-by="value"
                                    :class="{
                                          'is-invalid': submitted && $v.form.industry.$error,
                                      }"
                                  ></multiselect>
                                  <div
                                      v-if="submitted && $v.form.industry.$error"
                                      class="invalid-feedback"
                                      >
                                          <span v-if="!$v.form.industry.required">
                                            {{$t("common.requiredError")}}.
                                          </span>
                                  </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="mb-3">
                                        <label class="form-label" for="wwt">{{$t("fem.wwt")}}</label>
                                        <input type="text" class="form-control" id="wwt"  v-model="form.companyInfo.wwt"
                                        :class="{
                                            'is-invalid': submitted && $v.form.companyInfo.wwt.$error,
                                        }">
                                        <div
                                            v-if="submitted && $v.form.companyInfo.wwt.$error"
                                            class="invalid-feedback"
                                            >
                                                <span v-if="!$v.form.companyInfo.wwt.required">
                                                  {{$t("common.pleaseDetail")}}.
                                                </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 mb-3">
                                  <label class="form-label" for="materials">{{$t("zero.materials")}}</label>
                                  <input type="text" class="form-control" id="materials"   v-model="form.companyInfo.materials"
                                  :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.materials.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.materials.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.materials.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                  <label class="form-label" for="productType">{{$t("fem.productType")}}</label>
                                  <input type="text" class="form-control" id="productType"   v-model="form.companyInfo.productType"
                                  :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.productType.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.productType.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.productType.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                  <label class="form-label" for="technology">{{$t("fem.technology")}}</label>
                                  <input type="text" class="form-control" id="technology"  v-model="form.companyInfo.technology"
                                  :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.technology.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.technology.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.technology.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-4 mb-3">
                                        <label class="form-label" for="cmc"> {{$t("zero.cmc")}}</label>
                                        <input type="text" class="form-control" id="cmc" v-model="form.companyInfo.cmc"
                                        :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.cmc.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.cmc.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.cmc.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                        <label class="form-label" for="numberofChemical"> {{$t("zero.numberofChemical")}}</label>
                                        <input type="text" class="form-control" id="numberofChemical" v-model="form.companyInfo.numberofChemical"
                                        :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.numberofChemical.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.numberofChemical.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.numberofChemical.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                                <div class="col-lg-4 mb-3">
                                        <label class="form-label" for="chemicalUsed"> {{$t("zero.chemicalUsed")}}</label>
                                        <input type="text" class="form-control" id="chemicalUsed" v-model="form.companyInfo.chemicalUsed"
                                        :class="{
                                          'is-invalid': submitted && $v.form.companyInfo.chemicalUsed.$error,
                                      }">
                                      <div
                                          v-if="submitted && $v.form.companyInfo.chemicalUsed.$error"
                                          class="invalid-feedback"
                                          >
                                              <span v-if="!$v.form.companyInfo.chemicalUsed.required">
                                                {{$t("common.requiredError")}}.
                                              </span>
                                      </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 mb-3">
                                        <label class="form-label" style="padding-right: 10px;"> {{$t("zero.mrsl")}}</label>
                                        <div class="form-check form-check-inline" v-for="(item,index) in lookupData.yesno" :key="index">
                                          <input
                                            type="radio"
                                            class="form-check-input"
                                            :value="item.value"
                                            v-model="form.companyInfo.mrsl"
                                          />
                                          <label class="form-check-label">{{item.label}}</label>
                                      </div>        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="card border shadow-none mb-3">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-shrink-0 me-3">
                                        <div class="avatar">
                                            <div class="avatar-title rounded-circle bg-soft-primary text-primary">
                                                03
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("common.contactInfo")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-contact-input">{{$t("common.contact")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-contact-input" v-model="form.contact"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.contact.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.contact.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.contact.required">
                                                              {{$t("common.contactError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6 mb-3">
                                              <label class="form-label" for="gen-info-title-input">{{$t("common.title")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-title-input" v-model="form.title"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.title.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.title.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.title.required">
                                                              {{$t("common.titleError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6 mb-3">
                                                    <label class="form-label" for="gen-info-mobile-input">{{$t("common.mobile")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-mobile-input" v-model="form.mobile"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.mobile.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.mobile.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.mobile.required">
                                                              {{$t("common.mobileError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                            <div class="col-lg-6 mb-3" >
                                                    <label class="form-label" for="gen-info-email-input">{{$t("common.email")}}</label>
                                                    <input type="text" class="form-control" id="gen-info-email-input" v-model="form.email"
                                                    :class="{
                                                        'is-invalid': submitted && $v.form.email.$error,
                                                    }">
                                                    <div
                                                        v-if="submitted && $v.form.email.$error"
                                                        class="invalid-feedback"
                                                        >
                                                            <span v-if="!$v.form.email.required">
                                                              {{$t("common.emailError")}}.
                                                            </span>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </form>
                          <div>
                              <button type="button" class="btn btn-primary w-sm" @click="handleSaveClient" :disabled="success" >{{$t("common.submit")}}</button> {{$t("common.hotline")}}: +86 755 21608956
                              <button type="button" class="btn btn-btn-secondary w-sm" @click="handleGoHome" v-if="false">{{$t("common.moreService")}}</button>
                          </div>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
  .is-invalid .multiselect__tags{
    border:1px solid #ec4561 !important;
  }
</style>
